
import { OnInit, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BindComponentService } from 'app/utils/bind.component.service';

/**
 * $Id$
 */
 
@Component({
    selector: 'modalReportComponent',
    templateUrl: './content.template.html'
})
export class ModalReportComponent implements OnInit {
    public fileName: string;
    public blobReport: Blob;

    constructor(private bindComponent: BindComponentService, private activeModal: NgbActiveModal) {
    }
    ngOnInit() {
    }

    private cancel() {
        this.activeModal.close('cancel');
    }

    private download() {
        let url = window.URL.createObjectURL(this.blobReport);
        var anchor = document.createElement("a");
        anchor.download = this.fileName;
        anchor.href = url;
        anchor.click();
        this.activeModal.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/app/utils/modals/report/content.component.ts